// import React, { Component } from 'react';
// import logo from './logo.svg';
// import './App.css';

import React from 'react';
import JourneyMasterUI from './components/JourneyMasterUI'
import { connect } from 'react-redux'

const App = (props) => {
   // if we are on a VERY tall screen, return two app instances, each
   // with a unique identifier ('top' / 'bottom'). The top will be
   // rotated appropriately.
   //
   // otherwise, just return a single normal instance
   if (props.windowHeight > 1920) {
      return (
         <div>
            <JourneyMasterUI galleryId={'top'} rotate={'rotate(180deg)'} />
            <JourneyMasterUI galleryId={'bottom'} rotate={'rotate(0deg)'} />
         </div>)
   } else {
      return (
         <div>
            <JourneyMasterUI galleryId={'bottom'} rotate={'rotate(0deg)'} />
         </div>)
   }
}

const mapStateToProps = (state, ownProps) => ({
   windowHeight: state.util.get('windowHeight'),
   windowWidth: state.util.get('windowWidth'),
   appHeight: state.util.get('appHeight'),
   appWidth: state.util.get('appWidth'),
   ...ownProps,
})

export default connect(
  mapStateToProps,
)(App)


// WEBPACK FOOTER //
// ./src/App.js